import { Platform } from 'react-native'

import type { UniversalWebViewProps } from './universalWebView/types'
import UniversalIframe from './universalWebView/UniversalIframe'
import UniversalRNWebView from './universalWebView/UniversalRNWebview'

export default function UniversalWebView<MData>(props: UniversalWebViewProps<MData>) {
  return Platform.OS === 'web' ? <UniversalIframe {...props} /> : <UniversalRNWebView {...props} />
}
